import React from 'react';
import { getGroupedIssuePosts } from '../../../model/post';
import { Section } from '../index';

const Standard = ({
  issue,
  lazyLoad
}) => {
  const {
    posts: { nodes: issuePosts },
  } = issue;

  const [spotlightPosts, restPosts] = getGroupedIssuePosts(issuePosts);

  return (
    <Section type="standard" spotlightPosts={spotlightPosts} restPosts={restPosts} issue={issue} lazyLoad={lazyLoad} />
  );
};

export default Standard;
